import { Injectable, Inject } from '@angular/core';
import { Observable, throwError, of } from "rxjs";
import 'rxjs/add/operator/map';
import 'rxjs/operator';
import 'rxjs/add/operator/catch';
import { HttpClient } from "@angular/common/http";
import { BaseService } from './BaseService';
import { ILookupBase } from '../Models/ILookupBase';
import { IReportPDF } from '../Models/IReportPDF';
import { IAttendanceSchedule } from '../Models/IAttendanceSchedule';
import { ISitePauDetail } from '../Models/ISitePauDetail';
import { IProviderCertificationRequest } from '../Models/IProviderCertificationRequest';

@Injectable()
export class SiteService extends BaseService {
  _baseUrl: string = "";
  constructor(protected _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    super(_http);
    this._baseUrl = baseUrl;
  }

  get121Sites(selectedYearPeriod: string): Observable<[ILookupBase[]]> {
    return this._http.get<[ILookupBase[]]>(this._baseUrl + 'api/Site/Get121Sites/' + selectedYearPeriod)
      .map((response: [ILookupBase[]]) => response as [ILookupBase[]])
      .catch(this.handleError);
  }

  getAdministratorUncertifiedServiceRegister(serviceRegisterCertificationId: string): Observable<IReportPDF> {
    return this._http.get<IReportPDF>(this._baseUrl + 'api/Site/GetAdministratorUncertifiedServiceRegister/' + serviceRegisterCertificationId)
      .map((response: IReportPDF) => response as IReportPDF)
      .catch(this.handleError);
  }

  getAdministratorCertifiedServiceRegister(serviceRegisterCertificationId: string): Observable<IReportPDF> {
    return this._http.get<IReportPDF>(this._baseUrl + 'api/Site/GetAdministratorCertifiedServiceRegister/' + serviceRegisterCertificationId)
      .map((response: IReportPDF) => response as IReportPDF)
      .catch(this.handleError);
  }

  get121TargetAttendanceSchedule(): Observable<IAttendanceSchedule> {
    return this._http.get<IAttendanceSchedule>(this._baseUrl + 'api/Site/Get121TargetAttendanceSchedule')
      .map((response: IAttendanceSchedule) => response as IAttendanceSchedule)
      .catch(this.handleError);
  }

  get121SitePauDetailsList(): Observable<ISitePauDetail[]> {
    return this._http.get<ISitePauDetail[]>(this._baseUrl + 'api/Site/Get121SitePauDetailsList')
      .map((response: ISitePauDetail[]) => response as ISitePauDetail[])
      .catch(this.handleError);
  }

  getSitePauDetails(siteId: string): Observable<ISitePauDetail[]> {
    return this._http.get<ISitePauDetail[]>(this._baseUrl + 'api/Site/GetSitePauDetails/' + siteId)
      .map((response: ISitePauDetail[]) => response as ISitePauDetail[])
      .catch(this.handleError);
  }

  getActiveSiteDetails(): Observable<ISitePauDetail[]> {
    return this._http.get<ISitePauDetail[]>(this._baseUrl + 'api/Site/GetActiveSiteDetails')
      .map((response: ISitePauDetail[]) => response as ISitePauDetail[])
      .catch(this.handleError);
  }

  insertProviderCertification(ProviderCertificationRequest: IProviderCertificationRequest): Observable <number> {
    return this._http.post<number> (this._baseUrl + 'api/Site/InsertProviderCertification', ProviderCertificationRequest)
      .map((response: number) => response as number)
      .catch(this.handleError);
  }

  certifyAdministrator(certificationId: number): Observable<boolean> {
    return this._http.get<boolean>(this._baseUrl + 'api/Site/CertifyAdministrator/' + certificationId)
      .map((response: boolean) => response as boolean)
      .catch(this.handleError);
  }

}
